import axios from 'axios';

const server = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: { 'Content-Type': 'application/json' }
})


//Class to manage the fetch to the API of the delivery fee rules
export class DeliveryFeeRulesFetchAPI {

    //Function to get delivery fee rules by business
    static async getDeliveryFeeRulesByBusiness(business_id, token) {
        const res = await server(`/delivery-fees-rules?business_id=${business_id}`, {
            method: "get",
            headers: { 'x-access-token': token },
        });
        return res
    }

    //Funtion to create a delivery fee rule
    static async createDeliveryFeeRule(data, token) {
        const res = await server('/delivery-fees-rules', {
            method: "post",
            headers: { 'x-access-token': token },
            data: data
        });
        return res
    }

    //Function to update a delivery fee rule
    static async updateDeliveryFeeRule(id, data, token) {
        const res = await server(`/delivery-fees-rules/${id}`, {
            method: "put",
            headers: { 'x-access-token': token },
            data: data
        });
        return res
    }

    //Function to delete a delivery fee rule
    static async deleteDeliveryFeeRule(id, token) {
        const res = await server(`/delivery-fees-rules/${id}`, {
            method: "delete",
            headers: { 'x-access-token': token },
        });
        return res
    }

    //Function to get de details of a delivery fee rule
    static async getDeliveryFeeRuleDetails(id, token) {
        const res = await server(`/delivery-fees-rules/${id}`, {
            method: "get",
            headers: { 'x-access-token': token },
        });
        return res
    }

    //Function to assing a tax to a delivery fee rule 
    static async asignTaxesToDeliveryFeeRule(data, token) {
        const res = await server(`/taxes/delivery-fees-rules`, {
            method: "post",
            headers: { "x-access-token": token },
            data
        })
        return res
    }

    //Function to delete a tax from a delivery fee rule 
    static async removeTaxFromDeliveryRule(data, token) {
        const res = await server(`/taxes/delivery-fees-rules`, {
            method: "delete",
            headers: { "x-access-token": token },
            data
        })
        return res
    }


}